"use client";

import { useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import Link from "next/link";
import { useAuth } from "@/providers/AuthContext";
import { leavePublicSite } from "@/lib/publicSite";
import { DesktopNavigation } from "@/components/ui/DesktopNavigation";
import { MobileNavigation } from "@/components/ui/MobileNavigation";

import styles from './Header.module.css';

interface HeaderProps {
  onContactClick?: () => void;
}

export function Header({ onContactClick = () => {} }: HeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const router = useRouter();
  const pathname = usePathname();

  const handleContactClick = () => {
    if (pathname === "/") {
      onContactClick();
    } else {
      router.push("/#contact");
    }
  };

  // Into the application, so a full page load: the public pages' tag
  // manager must not come along (see lib/publicSite.ts).
  const handleAuthAction = () => {
    leavePublicSite(isAuthenticated ? "/dashboard" : "/login");
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* Logo / Brand */}
        <Link 
          href="/" 
          className={styles.logo}
        >
          Applied Language Institute
        </Link>

        {/* Desktop Nav */}
        <div className={styles.navContainer}>
          <DesktopNavigation
            isAuthenticated={isAuthenticated}
            onContactClick={handleContactClick}
            onAuthAction={handleAuthAction}
          />

          <MobileNavigation
            isMenuOpen={isMenuOpen}
            isAuthenticated={isAuthenticated}
            onToggleMenu={toggleMenu}
            onContactClick={handleContactClick}
            onMenuItemClick={handleMenuItemClick}
          />
        </div>
      </div>

    </header>
  );
}
